import { TranscoderJobViewModel } from '../transcoder-job-view.model';
import { EMediaTranscodingItemStatus } from '../../../../domain/media-transcoder/transcoding-item';
import {
  RedoJobState,
  TranscodingBulkRedoTracker,
} from '../../../../domain/media-transcoder/transcoding-bulk-redo-tracker';

export class HistoryTranscoderJobViewModel extends TranscoderJobViewModel {
  redoJobId: string | null = null;
  redoJobName: string | null = null;
  redoState: RedoJobState | null = null;
  constructor(
    id: string,
    name: string,
    destination: string,
    actualStartTime: string,
    actualEndTime: string,
    estimatedEndTime: string,
    duration: string,
    status: string,
    priority: string,
    public itemStatuses: EMediaTranscodingItemStatus[],
    transcodingProfile?: number,
    public sideEffectId = 0,
  ) {
    super(
      id,
      name,
      destination,
      actualStartTime,
      actualEndTime,
      estimatedEndTime,
      duration,
      status,
      priority,
      transcodingProfile,
    );
  }

  get itemStatusDisplay(): string {
    if (!this.itemStatuses?.length) {
      return '';
    }

    return this.itemStatuses
      .map((s) => EMediaTranscodingItemStatus[s])
      .filter((name) => !!name)
      .join(', ');
  }

  get hasRedoLink(): boolean {
    return this.redoJobId != null;
  }

  get redoStatusLabel(): string {
    if (!this.redoState) {
      return '';
    }
    return TranscodingBulkRedoTracker.redoStatusLabel(this.redoState);
  }

  get redoSucceeded(): boolean {
    return this.redoState === 'completed';
  }

  assignRedo(
    redoJobId: string,
    redoJobName: string,
    redoState: RedoJobState,
  ): void {
    this.redoJobId = redoJobId;
    this.redoJobName = redoJobName;
    this.redoState = redoState;
  }
}
